import React from "react";
import { Box, Typography } from "@material-ui/core";

import { useAppSelector } from "store";
import { selectStore, selectComparator } from "modules/customer/insights/portfolioNew/portfolioSlice";

import useColourPalette from "components/visuals/useColourPalette";
import KPIComparison from "components/visuals/KPIComparison";

import numberFormatter from "utils/numberFormatter";
import { selectIsLoading, selectHasErrors, selectClassifiedCompetitorCounts } from "modules/customer/insights/portfolioNew/competitionNew/competitionNewSlice";
import mathUtils from "utils/mathUtils";

const NumberOfCompetitors = () => {
    const colourPalette = useColourPalette();
    const selectedStore = useAppSelector(selectStore);
    const selectedComparator = useAppSelector(selectComparator);
    const isLoading = useAppSelector(selectIsLoading);
    const hasErrors = useAppSelector(selectHasErrors);
    const competitorCounts = useAppSelector(selectClassifiedCompetitorCounts);
    const selectedStoreNumberOfCompetitors = competitorCounts.selectedStore?.competitors ?? 0;
    const comparatorNumberOfCompetitors = competitorCounts.comparator?.competitors ?? 0;
    const difference = mathUtils.safePercentageChange(selectedStoreNumberOfCompetitors, comparatorNumberOfCompetitors);
    const differencePositiveSign = difference > 0 ? "+" : "";

    const label = `Number of competitors within 10 minutes drive-time of your ${selectedStore?.name} store`;

    return (
        <Box width="100%" height="100%" data-cy="direct-competitors-within-10-minutes">
            <KPIComparison
                isLoading={isLoading}
                hasErrors={hasErrors}
                targetValue={
                    <Typography variant="h3" component="div" style={{ color: colourPalette.comparators[0] }}>
                        {selectedStoreNumberOfCompetitors}
                    </Typography>
                }
                targetLabel={label}
                comparisonValue={
                    <Typography variant="h6" component="div" style={{ color: colourPalette.comparators[1] }}>
                        {comparatorNumberOfCompetitors}
                    </Typography>
                }
                comparisonLabel={`Comparator: ${selectedComparator?.name} `}
                differenceValue={
                    <Typography variant="h6" component="div" style={{ color: "#FFFFFF" }}>
                        {differencePositiveSign}{numberFormatter.toPercentage(difference, true, 2)}
                    </Typography>
                }
                differenceLabel="Difference"
            />
        </Box>
    );
};

export default NumberOfCompetitors;
